/* Impolie — never recommend the product you are already looking at.
 *
 * "You may also like" now draws from a fixed summer collection rather than
 * Shopify's recommendation engine, which was mixing winter items in. A fixed
 * collection can include the current product, so this hides that one card.
 *
 * Only ever hides a card whose link matches the page you are on. If it cannot
 * work out which product that is, it does nothing.
 */
(function () {
  'use strict';

  function currentHandle() {
    var m = window.location.pathname.match(/\/products\/([a-z0-9-]+)/i);
    return m ? m[1].toLowerCase() : null;
  }

  function run() {
    var handle = currentHandle();
    if (!handle) return;

    var headings = document.querySelectorAll('h2, .title');
    var section = null;
    for (var i = 0; i < headings.length; i++) {
      if (/you may also like/i.test(headings[i].textContent || '')) {
        section = headings[i].closest('.shopify-section');
        break;
      }
    }
    if (!section) return;

    var cards = section.querySelectorAll('.grid__item');
    for (var j = 0; j < cards.length; j++) {
      var link = cards[j].querySelector('a[href*="/products/"]');
      if (!link) continue;
      var h = (link.getAttribute('href').match(/\/products\/([a-z0-9-]+)/i) || [])[1];
      if (h && h.toLowerCase() === handle) cards[j].style.display = 'none';
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
  setTimeout(run, 700);
})();
